module.exports = __webpack_public_path__ + "assets/img/frame.7be58bf3.png";